import { createSlice } from '@reduxjs/toolkit';
import { LocalStorer } from 'services/localStorer';
import { DepthTypes } from 'types/ghostMode';

import {
  GHOST_MODE_DEFAULT_DEPTH_TYPE,
  GHOST_MODE_DEPTH_TYPE_LOCAL_STORAGE_KEY,
} from './constants';
import {
  removeOffsetWellboreReducer,
  retrieveFromLocalStorageReducer,
  retrieveFullfilledReducer,
  retrieveOffsetsRejectedReducer,
  setCurrentWellboreTuwbiReducer,
  setDepthTypeReducer,
} from './reducers';
import { GhostModeState } from './state';
import { fetchOffsetById } from './thunks/fetch-offsets.thunk';

export const initialState: GhostModeState = {
  currentWellboreTuwbi: '',
  depthType:
    (LocalStorer.get(GHOST_MODE_DEPTH_TYPE_LOCAL_STORAGE_KEY) as DepthTypes) ??
    GHOST_MODE_DEFAULT_DEPTH_TYPE,
  offsets: {
    loading: false,
    error: false,
    offsetWellbores: [],
  },
};

const ghostModeSlice = createSlice({
  name: 'ghostMode',
  initialState,
  reducers: {
    setDepthType: setDepthTypeReducer,
    removeOffsetWellbore: removeOffsetWellboreReducer,
    setCurrentWellboreTuwbi: setCurrentWellboreTuwbiReducer,
    retrieveOffsetsFromLocalStorage: retrieveFromLocalStorageReducer,
  },
  extraReducers: builder => {
    builder.addCase(fetchOffsetById.fulfilled, retrieveFullfilledReducer);
    builder.addCase(fetchOffsetById.rejected, retrieveOffsetsRejectedReducer);
  },
});

export const {
  setDepthType,
  removeOffsetWellbore,
  retrieveOffsetsFromLocalStorage,
  setCurrentWellboreTuwbi,
} = ghostModeSlice.actions;
export default ghostModeSlice.reducer;
